import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { media } from '../styles/Mixin';

const Container = styled.input`    
  ${media.deskTop`${props => props.theme.deskSearchInputBox}`}
  ${media.mobile`${props => props.theme.mobileSearchInputBox}`}
`

const SearchInput = ({
    className,
    placeholder,
    required,
    value,
    onChange,
    type = "text",
    disabled,
}) => (
  <Container
    className={className}
    placeholder={placeholder}
    required={required}
    value={value}
    onChange={onChange}
    type={type}
    disabled={disabled}
  />
);

SearchInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string
};

export default SearchInput;
